import { Button as UIButton } from "@prismicio/editor-ui"
import { type MouseEvent, Suspense } from "react"
import { Link } from "react-router-dom"

import { useDocumentListBackLink } from "../../document/documentRouting"

/**
 * Basic icon button bringing the user back to the last/best known document list route.
 */
export function DocumentListBackButton() {
  return (
    <Suspense fallback={<Button link="/working" />}>
      <DataButton />
    </Suspense>
  )
}

function DataButton() {
  const link = useDocumentListBackLink()
  return <Button link={link} />
}

interface ButtonProps {
  link: string
}

function Button(props: ButtonProps) {
  const { link } = props

  function onClick(event: MouseEvent | KeyboardEvent) {
    if (
      window.confirm(
        "Do you want to leave the demo and return to https://prismic.io?",
      )
    ) {
      window.location.href = "https://prismic.io"
    }
    event.preventDefault()
  }

  return (
    <UIButton
      size="large"
      color="grey"
      endIcon="arrowBack"
      hiddenLabel="Back to document list"
      onClick={onClick}
      asChild
    >
      <Link to={link} />
    </UIButton>
  )
}
